<template>
  <div>
    <clients-table-head
      class="mt-5 mb-5"
      @changeComponent="changeComponent"
      @changePaidFilter="paidFilter = $event"
      :paid-filter="paidFilter"
    ></clients-table-head>
    <div>
      <v-text-field
        v-model="search"
        placeholder="Buscar clientes"
        color="primary"
        background-color="#DDDDE4"
        prepend-inner-icon="mdi-magnify"
        outlined
        hide-details
      ></v-text-field>
    </div>

    <div class="clients-table-scroll">
      <clients-table-item
        v-for="item in paginatedItems"
        :key="item._id"
        :item="item"
        @detail="detail"
        @edit="$emit('edit', $event)"
        @delete="$emit('delete', $event)"
      ></clients-table-item>
    </div>

    <v-progress-linear v-if="isLoading" indeterminate />

    <p v-if="!isLoading && itemsFiltersWithPaid.length === 0" class="text-center mt-2">
      No hay resultados
    </p>

    <div v-if="hasMore" class="text-center mt-4 mb-4">
      <v-btn depressed outlined color="primary" @click="loadMore">
        Cargar m&#225;s ({{ remaining }} restantes)
      </v-btn>
    </div>

    <p v-if="!isLoading && itemsFiltersWithPaid.length > 0" class="text-center text-caption grey--text mt-2">
      Mostrando {{ paginatedItems.length }} de {{ itemsFiltersWithPaid.length }} clientes
    </p>
  </div>
</template>

<script>
import Clients from "../../domain/Clients";

export default {
  name: "ClientsTable",
  mounted() {
    this.getAll();
  },
  components: {
    ClientsTableHead: () => import("./table/ClientsTableHead"),
    ClientsTableItem: () => import("./table/ClientsTableItem")
  },
  props: {
    updated: {
      type: Boolean,
      required: true
    },
    name: {
      type: String,
      required: false
    }
  },
  data: () => ({
    items: [],
    search: "",
    isLoading: true,
    paidFilter: false,
    visibleCount: 50
  }),
  methods: {
    changeComponent(component) {
      this.$emit("changeComponent", component);
    },
    async getAll() {
      try {
        this.items = await Clients.getAll('unsetOrPlan');
        this.isLoading = false;
      } catch (error) {
        console.warn(error);
      }
    },
    detail(id) {
      this.$emit("detail", id);
    },
    loadMore() {
      this.visibleCount += 50;
    }
  },
  computed: {
    itemsFilters() {
      if (!this.search) return this.items;
      var s = this.search.toUpperCase();
      return this.items.filter(function(item) {
        return (
          item._id.slice(-5).toUpperCase().includes(s) ||
          item.name.toUpperCase().includes(s) ||
          item.address.toUpperCase().includes(s) ||
          item.movilNumber.toString().includes(s)
        );
      });
    },
    itemsFiltersWithPaid() {
      if (!this.paidFilter) return this.itemsFilters;
      return this.itemsFilters.filter(function(item) { return item.paid === false; });
    },
    paginatedItems() {
      return this.itemsFiltersWithPaid.slice(0, this.visibleCount);
    },
    hasMore() {
      return this.itemsFiltersWithPaid.length > this.visibleCount;
    },
    remaining() {
      return this.itemsFiltersWithPaid.length - this.visibleCount;
    }
  },
  watch: {
    updated: async function() {
      if (this.updated) {
        this.items = [];
        await this.getAll();
        this.$emit("updatedComplete");
      }
    },
    search: function() {
      this.visibleCount = 50;
    },
    paidFilter: function() {
      this.visibleCount = 50;
    }
  }
};
</script>

<style lang="scss">
.info--number {
  width: 10%;
  min-width: 70px;
}
.info--name {
  width: 20%;
  min-width: 120px;
}
.info-typeUser {
  width: 10%;
  min-width: 60px;
}
.info--phone {
  width: 10%;
  min-width: 100px;
}
.info--address {
  width: 40%;
  min-width: 150px;
}
.info--actions {
  width: 10%;
  min-width: 120px;
}
</style>
